import React from 'react';

export default () => (
  <svg width="30" height="38">
    <g transform="translate(1 1)" fill="none" fillRule="evenodd">
      <ellipse fill="#EEE" cx="14" cy="34.056" rx="10" ry="2.056" />
      <path
        stroke="#E60278"
        strokeWidth="2"
        fillOpacity=".1"
        fill="#F90079"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M0 23.613h27.766L13.883 0z"
      />
      <path
        d="M13.883 7.404v8.236M13.883 19.09v-.052"
        stroke="#E60278"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
